<template>
  <FormsContainer />
</template>

<script>
import FormsContainer from "../containers/FormsContainer.vue";
import { mapState, mapActions } from "vuex";
import { Helper } from "../helpers";
import { HTTP } from "../utils/HTTP";
import uid from "uid";
export default {
  name: "TemplatesPage",
  components: {
    FormsContainer
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  beforeRouteLeave(to, from, next) {
    let formId = localStorage.getItem("activeFormId");
    if (formId) {
      next();
    } else {
      next(false);
    }
  },
  methods: {}
};
</script>

<style>
</style>